import { faLocationDot } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { List, ListItem } from '@mui/material';
import PortalLink from '../../common/PortalLink';
import { cleanUpID } from '../../common/utils';

const TutoringLocations = ({ row }) => {
  const locations = row.locations || [];
  const locationIdBase = cleanUpID(row.COURSE_TITLE) + '_' + row.SUBJECT + '_' + row.COURSE_NUMBER;
  const hasOneLocation = locations.length === 1;
  const preparedLocations = locations.map((location, index) => ({
    location,
    cleanLocationText: cleanUpID(location.text),
    displayComma: index !== locations.length - 1,
  }));

  const wrapperId = `tutoring__locationWrapper_${locationIdBase}`;
  const Wrapper = hasOneLocation ? 'div' : List;
  const wrapperProps = {
    id: wrapperId,
    className: 'locationsList',
  };

  const renderLocation = ({ location, cleanLocationText, displayComma }) => (
    <>
      <PortalLink
        id={`tutoring__location_url_${locationIdBase}_${cleanLocationText}`}
        target="_blank"
        href={location.url}
        className="noIcon"
      >
        {/* //if there is a location url then dont put the comma yet */}
        {location.text + (displayComma && !location?.mapUrl ? ',' : '')}
      </PortalLink>

      {location.mapUrl && (
        <>
          <PortalLink
            id={`tutoring__location_map_${locationIdBase}`}
            target="_blank"
            href={location.mapUrl}
            aria-label={`Map to ${location.text}`}
            className="noIcon" //no new tab icon, keep the icon below.
          >
            <FontAwesomeIcon
              id={`tutoring__location_icon_${locationIdBase}`}
              fixedWidth
              size="lg"
              icon={faLocationDot}
            />
          </PortalLink>
          {displayComma ? ', ' : ''}
        </>
      )}
    </>
  );

  const content = hasOneLocation
    ? renderLocation(preparedLocations[0])
    : preparedLocations.map((locationDetails) => (
        <ListItem
          id={`tutoring__locationWrapper_${locationIdBase}`}
          key={locationDetails.location.text}
        >
          {renderLocation(locationDetails)}
        </ListItem>
      ));

  return <Wrapper {...wrapperProps}>{content}</Wrapper>;
};

export default TutoringLocations;
